/**
 * @description returns false ONLY if value is null or undefined
 * - zero will return true
 * - empty string will also return true
 * - The "value i string | number" is a type guard that ensures the value is either string | number when the function returns true
 */
export const exists = (value: string | number | null | undefined | unknown): value is string | number => value != null
